module.exports = __webpack_public_path__ + "img/76200.86b552f8.jpg";